import { useEffect } from "react";
import { useAppDispatch } from "../../../services/redux/hooks/use-dispatch";
import { getStoresAction } from "../redux/actions/openai_store_actions";
import { APP_VECTOR_STORE_MODE } from "../../../services/api/constants";

export const useInitDatabase = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getStoresAction(APP_VECTOR_STORE_MODE))
      .unwrap()
      .catch((error) => {
        if (error.name === "ConditionError") {
          return;
        }
        console.error("Unexpected error:", error);
        throw new Error(error);
      });
  }, []);
};
